import React, { useState, Fragment, useEffect } from 'react';
import {
    Row, Button, Card,
    CardBody, CustomInput,
    FormGroup,
    Label,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup
} from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";

export default function AiVoiceChannel({
    templateData,
    updateTemplateData,
    assistantList,
    clickAiEmail,
    submit,
    isSuccess,
    id,
    stepCreate,
    userName,
    stepStatusMap,
}) {
    const [hasChanged, setHasChanged] = useState(false);
    const isUpdatedVoice = stepStatusMap?.aiVoice === "UpdatedOrCreated";
    const handleCreateVoice = async() =>{
        await submit()
    }
     const handleNotNow = async () => {
        await stepCreate({
            onboardSessionId: id,
            stepName: "voice-agent",
            status: "Skipped",
            creator: userName,
            modifiedBy: "Dashboard",
        });
        clickAiEmail()

       
    };


    return (
        <div className="mb-4 mt-4  ml-4">
            <Row>

                {/* ---------- AI VOICE ENABLED ---------- */}
                <Colxx sm={12} className="mb-2">
                    <h5>AI Voice Channel</h5>

                    <FormGroup>
                        <CustomInput
                            type="checkbox"
                            id="isAiVoice"
                            checked={true}
                            disabled={true}
                            label="AI Voice"
                        />
                    </FormGroup>
                </Colxx>

                {/* ---------- DYNAMIC FLOW ---------- */}
                {assistantList && assistantList.length > 0 && (
                    <Colxx xxs="12" className="mb-2">
                        <Label style={{ fontSize: "14px" }}>Dynamic Conversation Flow</Label>

                        <Input
                            className="input_sty w-80"
                            type="select"
                            value={templateData.dynamicFlowId || ""}
                            onChange={(e) => {
                                updateTemplateData("dynamicFlowId", e.target.value || null)
                                setHasChanged(true)
                            }
                            }
                        >
                            <option value="">Select a Dynamic Conversation Flow</option>


                            {assistantList.map((assist, index) => (
                                <option key={index} value={assist.openAiAssistantId}>
                                    {assist.name} ({assist.openAiAssistantId})
                                </option>
                            ))}
                        </Input>
                    </Colxx>
                )}

                <Colxx xxs="12" className="mb-4 text-right" style={{ marginTop: '80px' }}>
                    {isUpdatedVoice && !hasChanged ? (
                        <Button
                            color="primary"
                            size="lg"
                            outline
                            className=" mr-1"
                            onClick={clickAiEmail}
                        >
                            Next
                        </Button>
                    ) : (
                        <div className='widget-wrap'>

                            <Button
                                color="primary"
                                size="lg"
                                outline
                                className="mr-1"
                                onClick={handleCreateVoice}
                            >
                                Create AI Voice Channel
                            </Button>
                            <h6
                                style={{ display: 'flex' }}
                                className="ml-4 not-now"
                                onClick={handleNotNow}
                            >
                                Not Now <svg className='not-now' width="60" height="20" viewBox="70 15 40 20" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M60 25 H100 L90 15 M100 25 L90 35"
                                        fill="none"
                                        stroke="grey"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>

                            </h6>
                        </div>
                    )}
                </Colxx>
            </Row>
        </div>

    );
}